export default "__VITE_ASSET__BdE8b0ti__"